// Contact Form JavaScript
class ContactForm {
  constructor() {
    this.form = document.querySelector('.contact-form');
    this.submitButton = document.querySelector('.contact-form__button');
    this.init();
  }

  init() {
    if (!this.form) return;

    this.setupValidation();
    this.setupSubmitHandler();
    this.setupAutoResize();
  }

  setupValidation() {
    const inputs = this.form.querySelectorAll('.contact-form__input, .contact-form__textarea');
    
    inputs.forEach(input => {
      // Real-time validation
      input.addEventListener('blur', () => this.validateField(input));
      input.addEventListener('input', () => this.clearFieldError(input));
    });
  }

  setupSubmitHandler() {
    this.form.addEventListener('submit', (e) => {
      // Validate form before submission
      if (!this.validateForm()) {
        e.preventDefault();
        this.scrollToFirstError();
        return false;
      }
      
      // Let Shopify handle the form submission naturally
      // Just show loading state
      this.setLoadingState(true);
    });
  }

  setupAutoResize() {
    const textarea = this.form.querySelector('.contact-form__textarea');
    if (textarea) {
      textarea.addEventListener('input', () => {
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
      });
    }
  }

  validateField(field) {
    const fieldContainer = field.closest('.contact-form__field');
    const isValid = this.isFieldValid(field);

    if (!isValid) {
      fieldContainer.classList.add('has-error');
      this.showFieldError(field);
    } else {
      fieldContainer.classList.remove('has-error');
      this.clearFieldError(field);
    }

    return isValid;
  }

  isFieldValid(field) {
    const value = field.value.trim();
    const type = field.type;
    const required = field.hasAttribute('required');

    if (required && !value) {
      return false;
    }

    if (type === 'email' && value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value);
    }

    if (type === 'tel' && value) {
      const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
      return phoneRegex.test(value.replace(/\s/g, ''));
    }

    return true;
  }

  showFieldError(field) {
    const fieldContainer = field.closest('.contact-form__field');
    let errorElement = fieldContainer.querySelector('.field-error');

    if (!errorElement) {
      errorElement = document.createElement('div');
      errorElement.className = 'field-error';
      errorElement.style.cssText = `
        color: #e74c3c;
        font-size: 0.875rem;
        margin-top: 0.25rem;
        font-weight: 500;
      `;
      fieldContainer.appendChild(errorElement);
    }

    const message = this.getErrorMessage(field);
    errorElement.textContent = message;
  }

  clearFieldError(field) {
    const fieldContainer = field.closest('.contact-form__field');
    const errorElement = fieldContainer.querySelector('.field-error');
    
    if (errorElement) {
      errorElement.remove();
    }
    
    fieldContainer.classList.remove('has-error');
  }

  getErrorMessage(field) {
    const type = field.type;
    const required = field.hasAttribute('required');

    if (required && !field.value.trim()) {
      return `${field.getAttribute('placeholder') || 'Este campo'} es requerido`;
    }

    if (type === 'email' && field.value) {
      return 'Por favor ingresa un email válido';
    }

    if (type === 'tel' && field.value) {
      return 'Por favor ingresa un número de teléfono válido';
    }

    return 'Campo inválido';
  }

  validateForm() {
    const inputs = this.form.querySelectorAll('.contact-form__input, .contact-form__textarea');
    let isValid = true;

    inputs.forEach(input => {
      if (!this.validateField(input)) {
        isValid = false;
      }
    });

    return isValid;
  }

  scrollToFirstError() {
    const firstError = this.form.querySelector('.has-error');
    if (firstError) {
      firstError.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
      firstError.querySelector('input, textarea').focus();
    }
  }

  setLoadingState(loading) {
    if (loading) {
      this.form.classList.add('contact-form--loading');
      this.submitButton.disabled = true;
    } else {
      this.form.classList.remove('contact-form--loading');
      this.submitButton.disabled = false;
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ContactForm();
});

// Export for potential use in other modules
if (typeof module !== 'undefined' && module.exports) {
  module.exports = ContactForm;
}
